import {DataLayerPushEvent} from "tracking/core/types";

type WindowWithDataLayer = Window & {
    dataLayer?: DataLayerPushEvent[];
};

export async function waitForDataLayer(): Promise<void> {
    if (typeof window === "undefined") return;
    const w = window as WindowWithDataLayer;
    w.dataLayer = w.dataLayer || [];
}

export function pushToDataLayerObject(obj: DataLayerPushEvent): void {
    try {
        if (typeof window === "undefined") return;
        const w = window as WindowWithDataLayer;
        w.dataLayer = w.dataLayer || [];
        w.dataLayer.push(obj);
    } catch (e) {
        console.error("[tracking][dataLayerAdapter] dataLayer push failed:", e);
    }
}